import React from "react";

import CategoryPage from "../components/AC-Stores/components/StoreProducts";

import Layout from "../other/layout";
import SEO from "../other/seo";
import StoresGatsby from "../components/AC-Stores/StoresGatsby";
import { graphql } from "gatsby";
import { Router } from "@reach/router";

const IndexPage = ({
  data,
  pageContext = { pageCount: 1, currentPage: 1, url: "stores" },
}) => {
  let navCategory = data.allAvettiMenu.edges[0].node.childs.filter((chil) =>
    chil.URL.includes("stores")
  )[0];

  return (
    <Layout>
      <SEO title="Stores" />

      <StoresGatsby
        default
        data={data.allAvettiCategory.nodes[0]}
        pageContext={pageContext}
        navCategory={navCategory}
        supplier={[]}
      />
    </Layout>
  );
};

export const query = graphql`
  query StoresGraphl {
    allAvettiMenu {
      edges {
        node {
          name
          childs {
            name
            cid
            URL
            description
            image
            metadescription
            metakeywords
            position
            thumbnail
            vid
            properties {
              propname
              propvalue
            }
          }
        }
      }
    }
    allAvettiCategory(filter: { url: { eq: "stores" } }) {
      nodes {
        cid
        url
        name
        meta {
          metadescription
          metakeywords
        }
        image
        itemsCount
        numberOfPages
        description
        itemsFirstPage {
          id
          title
          code
          desc
          currency_sign
          image
          itemLargeImage
          price {
            value {
              integer
              decimal
            }
          }
          url
          properties {
            lng
            lat
            Website
            UPC
            Sys_Package_Price_Enabled
            Sys_Num_Images
            Supplier_Item_Code
            ProvinceAbv
            Province
            Phone

            LineAddress1
            Email
            Created_By_Supplier
            Country
            City

            createtime
          }
        }
        otherPages {
          _2 {
            id
            title
            code
            desc
            currency_sign
            image
            itemLargeImage
            price {
              value {
                integer
                decimal
              }
            }
            url
            properties {
              Sys_Num_Images
            }
          }
          _3 {
            id
            title
            code
            desc
            currency_sign
            image
            itemLargeImage
            price {
              value {
                integer
                decimal
              }
            }
            url
            properties {
              Sys_Num_Images
            }
          }
        }
        facets {
          Other {
            name
            title
            facetValues {
              count
              name
              removeText
              text
              value
            }
          }
          Price {
            count
            removeText
            text
            value
          }
          Reviews {
            count
            removeText
            text
            value
          }
        }
      }
    }
  }
`;

export default IndexPage;
